<div class="SLV2-mcrd-compltn-modal-area">
    <!-- <button class="SLV2-popup-close-btn" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button> -->
    <img src="selflearnv2-ui/assets/img/self-learn-v2/animated-well-done-tick.gif" class="SLV2-mcrd-compltn-icon" />
    <h5 class="SLV2-mcrd-compltn-hdng">Well Done!</h5>
    <h6 class="SLV2-mcrd-compltn-text" *ngIf="data.isFromMemoryCards">You’ve revised all the flashcards</h6>
    <button class="SLV2-mcrd-compltn-blue-btn" *ngIf="data.isFromMemoryCards" (click)="goToChapter()">Continue</button>
    <h6 class="SLV2-mcrd-compltn-text" *ngIf="!data.isFromMemoryCards">You’ve revised all your flashcards for today</h6>
    <button class="SLV2-mcrd-compltn-blue-btn" *ngIf="!data.isFromMemoryCards" (click)="goToChapter()">Continue Learning</button>
</div>
